import { Injectable } from '@angular/core';
import { Http } from '@angular/http';
import { Observable } from 'rxjs/Observable';
import { environment } from '../../../environments/environment';
import { District } from '../models/District';

@Injectable()
export class DistrictService {
  constructor(private http: Http) {}

  getByCounty(countyId: number): Observable<any> {
    const url = environment.api.baseUrl + environment.api.district.replace('{countyId}', countyId.toString());
    return this.http.get(url).map(res => {
      return res.json().map(j => new District(j));
    });
  }
}



// WEBPACK FOOTER //
// E:/proj/news12/zb-n12/scadmin/client/src/app/shared/services/district.service.ts